import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTenant } from '../../context/TenantContext';
import api from '../../services/api';
import '../../styles/header.css';

const Header = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const { business } = useTenant();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (user && business) {
      loadNotifications();
    }
  }, [user, business]);

  const loadNotifications = async () => {
    try {
      const response = await api.get('/reports.php/notifications');
      if (response.data && response.data.notifications) {
        setNotifications(response.data.notifications);
      }
    } catch (error) {
      console.error('Failed to load notifications:', error);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <button
          type="button"
          className="mobile-toggle-btn"
          aria-label="Open menu"
          onClick={toggleSidebar}
        >
          ☰
        </button>
        <div className="page-title">
          {business?.business_name && (
            <span className="business-name">{business.business_name}</span>
          )}
        </div>
      </div>

      <div className="header-right">
        {/* Search */}
        <div className="header-search">
          <input
            type="text"
            placeholder="Search..."
            className="search-input"
          />
        </div>

        {/* Notifications */}
        <div className="header-notifications">
          <button 
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <span className="notification-icon">🔔</span>
            {notifications.length > 0 && (
              <span className="notification-badge">{notifications.length}</span>
            )}
          </button>
          
          {showNotifications && (
            <div className="notifications-dropdown">
              <div className="notifications-header">
                <h3>Notifications</h3>
                <button onClick={() => setNotifications([])}>Dismiss All</button>
              </div>
              <div className="notifications-list">
                {notifications.length === 0 ? (
                  <div style={{ padding: '15px', textAlign: 'center', color: '#666' }}>No new notifications</div>
                ) : (
                  notifications.map((notif, index) => (
                    <div key={index} className="notification-item unread">
                      <div className="notification-icon">{notif.icon}</div>
                      <div className="notification-content">
                        <div className="notification-title">{notif.title}</div>
                        <div className="notification-message">{notif.message}</div>
                        <div className="notification-time">{notif.time}</div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

        {/* User Menu */}
        <div className="header-user">
          <button 
            className="user-menu-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar">
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
            <div className="user-info">
              <div className="user-name">
                {user?.first_name} {user?.last_name}
              </div>
              <div className="user-role">{user?.role}</div>
            </div>
            <span className="dropdown-arrow">▼</span>
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="dropdown-header">
                <div className="user-avatar-large">
                  {user?.first_name?.[0]}{user?.last_name?.[0]}
                </div>
                <div className="user-details">
                  <div className="user-fullname">
                    {user?.first_name} {user?.last_name}
                  </div>
                  <div className="user-email">{user?.email}</div>
                </div>
              </div>
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => navigate('/profile')}>
                  <span className="item-icon">👤</span>
                  My Profile
                </button>
                <button className="dropdown-item" onClick={() => navigate('/settings')}>
                  <span className="item-icon">⚙️</span>
                  Settings
                </button>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout" onClick={handleLogout}>
                  <span className="item-icon">🚪</span>
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;